// extracted by mini-css-extract-plugin
export default {"mCard":"IB-z","image":"JB-z","imageNoBackground":"KB-z","imageHasCategory":"LB-z","fullWidth":"MB-z"};